import Mutations from '../../odata/mutations';

export default { ...new Mutations('eventImage'), ...new Mutations('eventImages') };
